import { useEffect, useState } from 'react';
import api from '../api/axios';
import './AllAssignedLeads.css';

function AllAssignedLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterEmployee, setFilterEmployee] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    fetchAllLeads();
    fetchEmployees();
  }, []);

  const fetchAllLeads = async () => {
    try {
      console.log('Fetching all assigned leads...');
      const response = await api.get('/lead-assignments');
      console.log('Assigned leads:', response.data);
      setLeads(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching leads:', error);
      setLoading(false);
    }
  };

  const fetchEmployees = async () => {
    try {
      const response = await api.get('/employees');
      const salesEmps = response.data.filter(emp => emp.role?.name === 'Sales');
      setEmployees(salesEmps);
    } catch (error) {
      console.error('Error fetching employees:', error);
    }
  };

  // Filter leads based on selected filters
  const filteredLeads = leads.filter((lead) => {
    const employeeMatch = !filterEmployee || lead.employee?._id === filterEmployee;
    const statusMatch = !filterStatus || lead.status === filterStatus;
    return employeeMatch && statusMatch;
  });

  const getStatusBadgeColor = (status) => {
    const colors = {
      new: '#2196F3',
      contacted: '#FF9800',
      interested: '#4CAF50',
      negotiating: '#9C27B0',
      won: '#4CAF50',
      lost: '#F44336'
    };
    return colors[status] || '#999';
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <p>Loading leads...</p>
      </div>
    );
  }

  return (
    <div className="all-assigned-leads">
      <h2 style={{ marginBottom: '20px' }}>📊 All Assigned Leads Tracking</h2>
      
      {/* Filters */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '25px' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333' }}>
            Filter by Employee
          </label>
          <select
            value={filterEmployee}
            onChange={(e) => setFilterEmployee(e.target.value)}
            style={{ 
              width: '100%', 
              padding: '10px', 
              border: '1px solid #ddd', 
              borderRadius: '4px',
              fontSize: '14px'
            }}
          >
            <option value="">All Employees</option>
            {employees.map((emp) => (
              <option key={emp._id} value={emp._id}>
                {emp.firstName} {emp.lastName} ({emp.employeeId})
              </option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333' }}>
            Filter by Status
          </label>
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            style={{ 
              width: '100%', 
              padding: '10px', 
              border: '1px solid #ddd', 
              borderRadius: '4px',
              fontSize: '14px'
            }}
          >
            <option value="">All Status</option>
            <option value="new">New</option>
            <option value="contacted">Contacted</option>
            <option value="interested">Interested</option>
            <option value="negotiating">Negotiating</option>
            <option value="won">Won</option>
            <option value="lost">Lost</option>
          </select>
        </div>
      </div>

      {/* Leads Table */}
      {filteredLeads.length > 0 ? (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Lead Name</th>
                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Contact Number</th>
                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Email</th>
                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Company</th>
                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Assigned to</th>
                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Status</th>
                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Notes</th>
                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Assigned by</th>
                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredLeads.map((lead) => (
                <tr key={lead._id} style={{ borderBottom: '1px solid #eee', hover: { backgroundColor: '#f9f9f9' } }}>
                  <td style={{ padding: '12px', color: '#333' }}>
                    <strong>{lead.leadName}</strong>
                  </td>
                  <td style={{ padding: '12px', color: '#666' }}>
                    {lead.contactNumber && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <a 
                          href={`tel:${lead.contactNumber}`} 
                          style={{ 
                            display: 'inline-flex', 
                            alignItems: 'center', 
                            gap: '6px',
                            color: '#667eea',
                            textDecoration: 'none',
                            fontWeight: '500'
                          }}
                          title="Click to call"
                        >
                          📞 {lead.contactNumber}
                        </a>
                        <a 
                          href={`https://wa.me/${lead.contactNumber.replace(/[^0-9]/g, '')}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ 
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '28px',
                            height: '28px',
                            backgroundColor: '#25D366',
                            borderRadius: '50%',
                            textDecoration: 'none',
                            transition: 'transform 0.2s',
                            fontSize: '16px'
                          }}
                          title="WhatsApp"
                          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                        >
                          <svg viewBox="0 0 32 32" width="18" height="18" fill="white">
                            <path d="M16 0C7.164 0 0 7.164 0 16c0 2.777.709 5.39 1.955 7.665L.057 31.293l7.828-2.047A15.932 15.932 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.333c-2.496 0-4.87-.686-6.894-1.986l-.494-.3-5.13 1.342 1.37-4.998-.33-.513A13.288 13.288 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.335-10.015c-.401-.201-2.379-1.174-2.748-1.308-.369-.134-.638-.201-.906.201-.268.401-1.04 1.308-1.275 1.577-.234.268-.469.302-.87.101-2.412-1.208-3.996-2.155-5.587-4.882-.42-.721.42-.67 1.202-2.231.134-.268.067-.502-.033-.703-.101-.201-.906-2.179-1.241-2.982-.335-.804-.67-.67-.906-.67-.234 0-.502-.033-.77-.033s-.703.1-1.072.502c-.369.401-1.408 1.375-1.408 3.353s1.442 3.888 1.643 4.156c.201.268 2.814 4.295 6.819 6.022 2.513 1.074 3.52 1.174 4.79.988.771-.117 2.379-.972 2.714-1.911.335-.939.335-1.744.234-1.911-.1-.168-.368-.268-.77-.469z"/>
                          </svg>
                        </a>
                      </div>
                    )}
                    {!lead.contactNumber && '-'}
                  </td>
                  <td style={{ padding: '12px', color: '#666' }}>
                    {lead.email || '-'}
                  </td>
                  <td style={{ padding: '12px', color: '#666' }}>
                    {lead.company || '-'}
                  </td>
                  <td style={{ padding: '12px', color: '#333', fontWeight: '500' }}>
                    {lead.employee?.firstName} {lead.employee?.lastName}
                  </td>
                  <td style={{ padding: '12px' }}>
                    <span
                      style={{
                        display: 'inline-block',
                        padding: '6px 12px',
                        backgroundColor: getStatusBadgeColor(lead.status),
                        color: 'white',
                        borderRadius: '20px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                      }}
                    >
                      {lead.status}
                    </span>
                  </td>
                  <td style={{ padding: '12px', color: '#666', maxWidth: '200px', fontSize: '13px' }}>
                    {lead.notes ? (
                      <div title={lead.notes} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        {lead.notes.substring(0, 50)}
                        {lead.notes.length > 50 ? '...' : ''}
                      </div>
                    ) : (
                      <span style={{ color: '#999' }}>-</span>
                    )}
                  </td>
                  <td style={{ padding: '12px', color: '#666' }}>
                    {lead.assignedBy?.firstName} {lead.assignedBy?.lastName}
                  </td>
                  <td style={{ padding: '12px', color: '#666', fontSize: '13px' }}>
                    {new Date(lead.createdAt).toLocaleDateString('en-IN')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
          <p>No leads found matching the selected filters</p>
        </div>
      )}

      {/* Stats */}
      <div style={{ marginTop: '30px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '15px' }}>
        <div style={{ padding: '15px', backgroundColor: '#e3f2fd', borderRadius: '8px', textAlign: 'center' }}>
          <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#2196F3', margin: '0' }}>
            {leads.length}
          </p>
          <p style={{ fontSize: '12px', color: '#666', margin: '5px 0 0 0' }}>Total Leads</p>
        </div>
        <div style={{ padding: '15px', backgroundColor: '#fff3e0', borderRadius: '8px', textAlign: 'center' }}>
          <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#FF9800', margin: '0' }}>
            {leads.filter(l => l.status === 'contacted').length}
          </p>
          <p style={{ fontSize: '12px', color: '#666', margin: '5px 0 0 0' }}>Contacted</p>
        </div>
        <div style={{ padding: '15px', backgroundColor: '#f3e5f5', borderRadius: '8px', textAlign: 'center' }}>
          <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#9C27B0', margin: '0' }}>
            {leads.filter(l => l.status === 'negotiating').length}
          </p>
          <p style={{ fontSize: '12px', color: '#666', margin: '5px 0 0 0' }}>Negotiating</p>
        </div>
        <div style={{ padding: '15px', backgroundColor: '#e8f5e9', borderRadius: '8px', textAlign: 'center' }}>
          <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#4CAF50', margin: '0' }}>
            {leads.filter(l => l.status === 'won').length}
          </p>
          <p style={{ fontSize: '12px', color: '#666', margin: '5px 0 0 0' }}>Won</p>
        </div>
        <div style={{ padding: '15px', backgroundColor: '#ffebee', borderRadius: '8px', textAlign: 'center' }}>
          <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#F44336', margin: '0' }}>
            {leads.filter(l => l.status === 'lost').length}
          </p>
          <p style={{ fontSize: '12px', color: '#666', margin: '5px 0 0 0' }}>Lost</p>
        </div>
      </div>
    </div>
  );
}

export default AllAssignedLeads;
